import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagesComponent, RoleDetailsModel, RoleSaveModel, TranslationEntityComponent, ViewState, RolesService, Auth } from 'src/common';
import { Form, FormElement } from 'src/common/form';
import { TranslationManager } from 'src/common/translation';

@Component({
  selector: 'role',
  templateUrl: './role.component.html'
})
export class RoleComponent implements OnInit {

  @Input() state: ViewState;
  viewState = ViewState;
  form: Form = new Form();
  translationManager = TranslationManager;

  @ViewChild('translationEntityRoleName') translationEntityRoleName: TranslationEntityComponent;

  constructor(private rolesService: RolesService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    if (this.state == ViewState.Create) {
      Auth.checkAuthorization('1EE5706A-01F2-44A2-98AE-510C9605DEE4');
    } else if (this.state == ViewState.Details) {
      Auth.checkAuthorization('D04326D6-147C-461E-8EA1-7B22DF5F4A78');
    } else if (this.state == ViewState.Edit) {
      Auth.checkAuthorization('1EE5706A-01F2-44A2-98AE-510C9605DEE4');
    }

    this.initForm();

    if (this.state === ViewState.Edit || this.state === ViewState.Details) {
      this.form.elements['id'].value = this.route.snapshot.params.id;
      this.rolesService.getById(this.form.elements['id'].value).then((item: RoleDetailsModel) => {
        this.mapModelToForm(item);
      });
    }
  }

  private mapModelToForm(item: RoleDetailsModel) {
    this.form.elements['id'].value = item.id;
    this.form.elements['name'].value = item.name;
    this.form.elements['description'].value = item.description;

    this.form.elements['createdOn'].value = item.createdOn;
    this.form.elements['createdByName'].value = item.createdByName;
    this.form.elements['updatedOn'].value = item.updatedOn;
    this.form.elements["updatedByName"].value = item.updatedByName;

    //this.translationEntityRoleName.entity = item.translationName;
  }

  private initForm() {
    this.form.elements['id'] = new FormElement();
    this.form.elements['name'] = new FormElement();
    this.form.elements['name'].state.mandatory = true;
    this.form.elements['description'] = new FormElement();
    this.form.elements['description'].state.mandatory = false;

    this.form.elements["createdOn"] = new FormElement();
    this.form.elements["createdByName"] = new FormElement();
    this.form.elements["updatedOn"] = new FormElement();
    this.form.elements["updatedByName"] = new FormElement();
  }

  submit() {

    //if (this.form.isValid() && this.translationEntityRoleName.isValid()) {
if (this.form.isValid())
{
      let model: RoleSaveModel = new RoleSaveModel();

      model.id = this.form.elements['id'].value;
      model.name = this.form.elements['name'].value;
      model.description = this.form.elements['description'].value;

      //model.translationName = this.translationEntityRoleName.entity;

      this.rolesService.save(model).then(() => {
        if (this.state == ViewState.Create) {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
        } else if (this.state == ViewState.Edit) {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно измењени')]);
        }

        this.navigateToList();
      });
    }
  }

  navigateToList() {
    this.router.navigate(['/roles']);
  }
}
